<template>
  <div class="footer_container" :style="footerHeight + 'px'">
    <div class="footer_content">
      <div class="footer_logo footer-content-column">
        <div class="logo-container">
          <img :src="logo_url" alt="" />
        </div>
        <h2>© 2022-2023 北京天安智慧信息技术有限公司</h2>
        <h2>地址：北京市海淀区上地五街7号昊海大厦601室</h2>
        <h2>邮箱：service@tasmarter.com</h2>

        <div class="wrap">
          <img src="@/assets/img/index/jing.png" alt="jing" />
          <a
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802024697"
            style="color: #7b7e81"
            >京公网安备11010802024697号</a
          >
        </div>
        <div class="wrap">
          <img src="@/assets/img/index/jing.png" alt="jing" /> 
          <a href="https://beian.miit.gov.cn/" style="color: #7b7e81"
            >&copy; 京ICP备17028386号-1</a
          >
        </div>
      </div>
      <div class="product footer-content-column">
        <h2>核心产品</h2>
        <ul class="product_list">
          <li>
            <router-link to="/software/DATimsien" >天行实时数据云平台</router-link>
          </li>
          <li>
            <router-link to="/software/TimMonitor">天行智能生产监控系统</router-link>
          </li>
          <li>
            <router-link to="/software/TimRiver">天河流式计算引擎</router-link>
          </li>
          <li>
            <router-link to="/software/DMS">数据管理系统</router-link>
          </li>
        </ul>
      </div>
      <div class="about_us footer-content-column">
        <h2>关于我们</h2>
        <ul class="about_list">
          <li>
            <router-link to="/company">公司简介</router-link>
          </li>
          <li>
            <router-link to="/company">企业文化</router-link>
          </li>
        </ul>
      </div>
      <div class="contact_us footer-content-column">
        <h2>联系我们</h2>
        <ul class="contact_list">
          <li v-for="(item, index) in contact_way" :key="index">
            <a :href="'mailto:' + item.email">{{ item.name }}</a>
          </li>
        </ul>
      </div>
      <div class="focus_us footer-content-column" >
        <div class="qr_weixing">
          <img :src="weixing_qr" alt="" />
          <h2>关注官方微信公众号</h2>
        </div>
      </div>
      <!-- <div class="focus_us footer-content-column">   
        <h2>实时动态与招聘信息，扫码关注我们</h2>
        <div class="media">
          <div
            :class="item.name"
            v-for="(item, index) in focus_icon"
            :key="index"
          >
            <el-popover placement="top" trigger="hover">
              <div class="qr_popover">
                <img :src="item.qr" alt="" />
                <h2>{{ item.info }}</h2>
              </div>
              <img :src="item.path" :alt="item.name" slot="reference" />
            </el-popover>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
      footerHeight: '',
      curWidth: '',
      logo_url: require('@/assets/img/index/logo_white.png'),
      weixing_qr: require('@/assets/img/focus/qr_weixin.png'),
      contact_way: [
        {
          name: '招聘相关',
          email: 'hr@tasmarter.com'
        },
        {
          name: '商务合作',
          email: 'service@tasmarter.com'
        }
      ],
      focus_icon: [
        {
          name: 'weixin',
          path: require('@/assets/img/focus/weixin.svg'),
          qr: require('@/assets/img/focus/qr_weixin.png'),
          info: '关注官方微信公众号'
        }
      ]
    }
  },
  methods: {
    setFooterHeight () {
        this.curWidth = window.innerWidth
        if (this.curWidth <= 991) {
          this.footerHeight = 570 + 'px'
        } else {
          this.footerHeight = 280 + 'px'
        }
      }
    },
    created () {
      // 页面创建时执行一次getHeight进行赋值，顺道绑定resize事件
    //   // window.addEventListener('resize', this.setFooterHeight)
    //   // this.setFooterHeight()
    // }
  }
}
</script>

<style lang = "less" scoped>
* {
  margin: 0;
  padding: 0;
}
h2 {
  font-size: 100%;
  font-weight: 400;
  font-variant: normal;
}
.footer_container {
  width: 100%;
  background: #1f2329;
  padding-bottom: 60px;
}

.footer_content {
  max-width: 1440px;
  color: #fff;
  margin: 0 auto;
  padding: 69px 0 0;
  display: flex;
  flex-direction: row;
  align-items: flex-start;

  h2 {
    font-size: 14px;
    line-height: 22px;
    margin: 4px 0;
    color: #7b7e81;
  }

  .footer-content-column {
    flex: 1 1;
    color: #d2d3d4;
    position: relative;
    text-align: center;

    h2 {
      margin-bottom: 18px;
      font-size: 16px;
      font-weight: bold;
    }

    .about_list,
    .product_list,
    .contact_list {
      text-align: left;
      font-size: 14px;
      line-height: 22px;

      li {
        margin-left: 60px;
        margin-bottom: 15px;
      }

      a {
        color: #d2d3d4;
      }
    }
  }

  .about_us,
  .product,
  .contact_us {
    max-width: 205px;
  }

  .focus_us {
    text-align: left;
    padding-left: 73px;

    .media {
      margin-top: 18px;
      display: flex;
    }

    span {
      margin-right: 18px;
      flex: 0 0 auto;
    }

    img {
      width: 130px; //32px
    }

    .weixin img {
      width: 38px;
      position: relative;
      top: -2px;
    }

    h2 {
      text-align: left;
      font-size: 14px;
      font-weight: normal;
      margin-bottom: 4px;
    }
  }

  .footer_logo {
    margin-left: 96px;
    height: 55px;
    text-align: left;
    max-width: 382px;
    min-width: 350px;

    h2 {
      font-size: 14px;
      font-weight: normal;
      margin-bottom: 4px;
    }

    .logo-container {
      display: flex;
      margin-bottom: 9px;
      img {
        height: 50px;
      }
    }
  }
}

@media only screen and (max-width: 991px) {
  .footer_content {
    flex-direction: column;

    .footer-content-column {
      text-align: center;
      margin: 0 auto 0;

      h2 {
        text-align: center;
      }
      padding-left: 0;
    }
    .focus_us div:last-of-type > span {
      margin-right: 0;
    }
    .media {
      justify-content: center;
    }
    .logo-container {
      justify-content: center;
      text-align: left;
    }
  }
   
  .wrap {
    text-align: center;
    width: auto;
    padding-top: 5px;
    padding-left: 20px;
    font-size: 14px;
    float: left;
  }
  .wrap img {
    float: left;
    width: 20px;
    vertical-align: middle;
  }
  .wrap a {
    float: left;
  }
  .focus_us {
    text-align: center;
    padding-left: 10px;
  }
  .about_list,
  .product_list,
  .contact_list {
    margin: 0px , 0px;
  }
}

.qr_popover {
  width: 100%;
  text-align: center;

  img {
    width: 130px;
    height: 130px;
    margin-bottom: 10px;
  }
}

.qr_weixing {
  width: 100%;
  height: 100%;
  text-align: center;

  img {
    width: 130px;
    height: 130px;
    margin-bottom: 10px;
  }
}

.copy {
  font-size: 14px;
  font-weight: normal;
  margin-bottom: 4px;
  color: #7b7e81;
}
.wrap {
  text-align: center;
  width: auto;
  margin:0 auto;
  padding-top: 5px;
  padding-bottom: 5x;
  font-size: 14px;
  float: left;
}
.wrap img {
  float: left;
  width: 20px;
  vertical-align: middle;
}
.wrap a {
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue